export default "__VITE_ASSET__BYxJIHdS__"